import { useEffect, useState } from 'react';

const useIsScrolling = () => {
  const [isScrolling, setIsScrolling] = useState(false);

  useEffect(() => {
    let timer = null;
    const onScroll = () => {
      if (!isScrolling) setIsScrolling(true);
      if (timer !== null) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        if (isScrolling) setIsScrolling(false);
      }, 200);
    };
    window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [isScrolling]);

  return isScrolling;
};

export default useIsScrolling;
